import * as XLSX from "xlsx";

/**
 * Export data to an Excel file and trigger download.
 */
export function exportToExcel(data, columns, filename) {
  const rows = data.map((item) =>
    columns.reduce((row, col) => {
      row[col.header] = col.value(item);
      return row;
    }, {})
  );

  const ws = XLSX.utils.json_to_sheet(rows);

  // Auto-size columns
  const colWidths = columns.map((col) => {
    const headerLen = col.header.length;
    const maxDataLen = Math.max(
      ...data.map((item) => String(col.value(item) || "").length),
      0
    );
    return { wch: Math.min(Math.max(headerLen, maxDataLen) + 2, 40) };
  });
  ws["!cols"] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, filename);
}

/**
 * Read an Excel/CSV file and return rows as array of objects.
 * Keys are from the first row (headers).
 */
export function readExcelFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
        resolve(rows);
      } catch (err) {
        reject(new Error("Could not read file. Please check the format."));
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file."));
    reader.readAsArrayBuffer(file);
  });
}

/**
 * Generate a template Excel file for tenant import.
 */
export function downloadTenantTemplate() {
  const sample = [
    { Name: "Jane Doe", Phone: "0712345678", "House Number": "A1", "Property Name": "Riverside Apartments", "Rent (KES)": 15000, "Due Day": 5, "Deposit (KES)": 15000 },
    { Name: "John Smith", Phone: "0723456789", "House Number": "B2", "Property Name": "Riverside Apartments", "Rent (KES)": 20000, "Due Day": 1, "Deposit (KES)": 20000 },
  ];

  const ws = XLSX.utils.json_to_sheet(sample);
  ws["!cols"] = [
    { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 25 }, { wch: 12 }, { wch: 10 }, { wch: 14 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Tenants");
  XLSX.writeFile(wb, "paysafi-tenant-template.xlsx");
}
